import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  useTheme,
  Tabs,
  Tab,
} from "@mui/material";
import { ContentCopy, Close, Code } from "@mui/icons-material";
import { useParams } from "react-router-dom";
import { getCarrierByBusinessName } from "../redux/action/carrier";
import { useDispatch } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";

interface EmbedCodeModalProps {
  open: boolean;
  onClose: () => void;
  canonicalId: string;
}

const EmbedCodeModal: React.FC<EmbedCodeModalProps> = ({
  open,
  onClose,
  canonicalId,
}) => {
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState<"wordpress" | "react">(
    "wordpress"
  );
  const [copySuccess, setCopySuccess] = useState(false);
  const [currentDomain, setCurrentDomain] = useState("");
  const [carrier, setCarrier] = useState<any>(null);
  const { businessName } = useParams();
  // const dispatch = useDispatch();
  // const getCarrier = () => {
  //   dispatch<any>(getCarrierByBusinessName(businessName || ""))
  //     .then(unwrapResult)
  //     .then((res: any) => {
  //       console.log(res, "carr->>");
  //       setCarrier(res);
  //     })
  //     .catch((err: any) => {
  //       console.log(err);
  //     });
  // };
  // useEffect(() => {
  //   if (businessName && carrier !== null) {
  //     getCarrier();
  //   }
  // }, [businessName]);
  React.useEffect(() => {
    setCurrentDomain(`${window.location.protocol}//${window.location.host}`);
  }, []);

  const generateWordpressCode = () => {
    return `<!DOCTYPE html>
<div id="wordpress-floating-iframe-container">
  <style>
    .wp-floating-container {
      position: fixed;
      bottom: 30px;
      right: 30px;
      z-index: 1000;
      transition: all 0.3s ease;
    }
    
    .wp-floating-button {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background-color: #4285f4;
      color: white;
      border: none;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      transition: all 0.3s ease;
    }
    
    .wp-floating-button:hover {
      background-color: #3367d6;
      transform: scale(1.1);
    }
    
    .wp-iframe-container {
      position: fixed;
      bottom: 100px;
      right: 30px;
      width: 360px;
      height: 640px;
      background: white;
      border-radius: 16px;
      box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
      overflow: hidden;
      transform: scale(0);
      transform-origin: bottom right;
      transition: all 0.3s ease;
      opacity: 0;
      z-index: 999;
      border: 1px solid #e0e0e0;
    }
    
    .wp-iframe-container.open {
      transform: scale(1);
      opacity: 1;
    }
    
    .wp-iframe-container iframe {
      width: 100%;
      height: 100%;
      border: none;
    }
    
    .wp-close-btn {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background: #f44336;
      color: white;
      border: none;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 1001;
    }
    
    .wp-chatbot-icon {
      width: 30px;
      height: 30px;
      fill: white;
    }
    
    @media (max-width: 480px) {
      .wp-iframe-container {
        width: 100%;
        height: 70vh;
        bottom: 0;
        right: 0;
        border-radius: 16px 16px 0 0;
      }
      
      .wp-floating-container {
        bottom: 20px;
        right: 20px;
      }
    }
  </style>

  <div class="wp-floating-container">
    <button class="wp-floating-button" id="wpFloatingBtn">
    <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 5V20.7929C3 21.2383 3.53857 21.4614 3.85355 21.1464L7.70711 17.2929C7.89464 17.1054 8.149 17 8.41421 17H19C20.1046 17 21 16.1046 21 15V5C21 3.89543 20.1046 3 19 3H5C3.89543 3 3 3.89543 3 5Z"
          stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M15 12C14.2005 12.6224 13.1502 13 12 13C10.8498 13 9.79952 12.6224 9 12"
          stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M9 8.01953V8"
          stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M15 8.01953V8"
          stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
</button>
  </div>
  
  <div class="wp-iframe-container" id="wpIframeContainer">
    <button class="wp-close-btn" id="wpCloseBtn">×</button>
    <iframe id="wpAppFrame" src="${currentDomain}/${businessName}/${canonicalId}/select-service"></iframe>
  </div>

  <script>
    (function() {
      const floatingBtn = document.getElementById('wpFloatingBtn');
      const iframeContainer = document.getElementById('wpIframeContainer');
      const closeBtn = document.getElementById('wpCloseBtn');
      const appFrame = document.getElementById('wpAppFrame');
      
      floatingBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        iframeContainer.classList.toggle('open');
      }, true);
      
      closeBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        iframeContainer.classList.remove('open');
      }, true);
      
      document.addEventListener('click', function(e) {
        if (!iframeContainer.contains(e.target) && e.target !== floatingBtn && !floatingBtn.contains(e.target)) {
          iframeContainer.classList.remove('open');
        }
      });
      
      floatingBtn.addEventListener('click', function() {
        if (iframeContainer.classList.contains('open')) {
          appFrame.src = appFrame.src;
        }
      });
      
      function handleResize() {
        if (window.innerWidth <= 480) {
          iframeContainer.style.bottom = '0';
          iframeContainer.style.right = '0';
          iframeContainer.style.width = '100%';
          iframeContainer.style.height = '70vh';
          iframeContainer.style.borderRadius = '16px 16px 0 0';
        } else {
          iframeContainer.style.bottom = '100px';
          iframeContainer.style.right = '30px';
          iframeContainer.style.width = '360px';
          iframeContainer.style.height = '640px';
          iframeContainer.style.borderRadius = '16px';
        }
      }
      
      handleResize();
      window.addEventListener('resize', handleResize);
    })();
  </script>
</div>`;
  };

  const generateReactCode = () => {
    return `import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

const FloatingIframeButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const iframeContainerRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const {businessName} = useParams();
  
  const toggleIframe = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const closeIframe = () => {
    setIsOpen(false);
  };
  
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        iframeContainerRef.current &&
        !iframeContainerRef.current.contains(event.target as Node) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        closeIframe();
      }
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 480);
    };
    
    handleResize();
    window.addEventListener("resize", handleResize);
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("resize", handleResize);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (isOpen && iframeRef.current) {
      iframeRef.current.src = iframeRef.current.src;
    }
  }, [isOpen]);

  const ChatbotIcon = () => (
      <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 5V20.7929C3 21.2383 3.53857 21.4614 3.85355 21.1464L7.70711 17.2929C7.89464 17.1054 8.149 17 8.41421 17H19C20.1046 17 21 16.1046 21 15V5C21 3.89543 20.1046 3 19 3H5C3.89543 3 3 3.89543 3 5Z"
          stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M15 12C14.2005 12.6224 13.1502 13 12 13C10.8498 13 9.79952 12.6224 9 12"
          stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M9 8.01953V8"
          stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M15 8.01953V8"
          stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
  );

  const floatingContainerStyle: React.CSSProperties = {
    position: "fixed",
    bottom: isMobile ? "20px" : "30px",
    right: isMobile ? "20px" : "30px",
    zIndex: 1000,
    transition: "all 0.3s ease",
  };

  const floatingButtonStyle: React.CSSProperties = {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    backgroundColor: "#4285f4",
    color: "white",
    border: "none",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "24px",
    transition: "all 0.3s ease",
  };

  const iframeContainerStyle: React.CSSProperties = {
    position: "fixed",
    bottom: isMobile ? "0" : "100px",
    right: isMobile ? "0" : "30px",
    width: isMobile ? "100%" : "360px",
    height: isMobile ? "70vh" : "640px",
    background: "white",
    borderRadius: isMobile ? "16px 16px 0 0" : "16px",
    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)",
    overflow: "hidden",
    transform: isOpen ? "scale(1)" : "scale(0)",
    transformOrigin: "bottom right",
    transition: "all 0.3s ease",
    opacity: isOpen ? 1 : 0,
    zIndex: 999,
    border: "1px solid #e0e0e0",
  };
  
  const iframeStyle: React.CSSProperties = {
    width: "100%",
    height: "100%",
    border: "none",
  };
  
  const iframeSrc = \`${currentDomain}/${businessName}/${canonicalId}/select-service\`;
  
  return (
    <>
      <div style={floatingContainerStyle}>
        <button
          ref={buttonRef}
          onClick={toggleIframe}
          style={floatingButtonStyle}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = "#3367d6";
            e.currentTarget.style.transform = "scale(1.1)";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = "#4285f4";
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          <ChatbotIcon />
        </button>
      </div>
      <div ref={iframeContainerRef} style={iframeContainerStyle}>
        <iframe
          ref={iframeRef}
          src={iframeSrc}
          title="App Embed"
          allow="fullscreen"
          style={iframeStyle}
        />
      </div>
    </>
  );
};

export default FloatingIframeButton;`;
  };

  const handleCopyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 2000);
  };

  const handleTabChange = (
    event: React.SyntheticEvent,
    newValue: "wordpress" | "react"
  ) => {
    setActiveTab(newValue);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="embed-code-modal"
        aria-describedby="embed-code-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "90%", sm: "80%", md: "70%" },
            maxWidth: 900,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            outline: "none",
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography variant="h6">Embed Code</Typography>
            <IconButton onClick={onClose}>
              <Close />
            </IconButton>
          </Box>

          <Tabs value={activeTab} onChange={handleTabChange} sx={{ mb: 3 }}>
            <Tab label="WordPress" value="wordpress" />
            <Tab label="React" value="react" />
          </Tabs>

          {activeTab === "wordpress" && (
            <>
              <Typography variant="body1" mb={2}>
                Paste this code in your WordPress site's footer.php or in a
                custom HTML block.
              </Typography>
              <Box sx={{ position: "relative" }}>
                <TextField
                  fullWidth
                  multiline
                  rows={16}
                  value={generateWordpressCode()}
                  variant="outlined"
                  InputProps={{
                    readOnly: true,
                    style: { fontFamily: "monospace", fontSize: "0.8rem" },
                  }}
                  sx={{ mb: 2 }}
                />
                <IconButton
                  onClick={() => handleCopyToClipboard(generateWordpressCode())}
                  sx={{ position: "absolute", top: 8, right: 8 }}
                >
                  <ContentCopy />
                </IconButton>
              </Box>
            </>
          )}

          {activeTab === "react" && (
            <>
              <Typography variant="body1" mb={2}>
                Copy this React component code to use in other React
                applications and call in parent component:
              </Typography>
              <Box sx={{ position: "relative" }}>
                <TextField
                  fullWidth
                  multiline
                  rows={20}
                  value={generateReactCode()}
                  variant="outlined"
                  InputProps={{
                    readOnly: true,
                    style: { fontFamily: "monospace", fontSize: "0.75rem" },
                  }}
                  sx={{ mb: 2 }}
                />
                <IconButton
                  onClick={() => handleCopyToClipboard(generateReactCode())}
                  sx={{ position: "absolute", top: 8, right: 8 }}
                >
                  <ContentCopy />
                </IconButton>
              </Box>
              <Typography variant="body2" color="text.secondary">
                Import this component in your React application to add the
                floating iframe button.
              </Typography>
            </>
          )}
        </Box>
      </Modal>

      <Dialog
        open={copySuccess}
        onClose={() => setCopySuccess(false)}
        aria-labelledby="copy-success-dialog"
      >
        <DialogTitle>Success</DialogTitle>
        <DialogContent>
          <DialogContentText>Embed code copied to clipboard!</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCopySuccess(false)}>OK</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EmbedCodeModal;
